<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        icon="mdi-cube-outline"
        :breadcrumbs="breadcrumbs"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mb-5">
        <v-col class="text-right" cols="12">
          <v-btn
              color="primary"
              @click="add"
          >
            Thêm
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center" class="mt-n6 " justify="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="technology"
              :items-per-page="10"
              class="elevation-1">
            <template v-slot:item.photo_url="{ item }">
              <img :src=" item.photo_url ? url + item.photo_url : require('@/assets/images/logo_Eglife1.png')"
                   width="100">
            </template>
            <template v-slot:item.active="{ item }">
              <v-switch
                  v-model="item.active"
                  class="pa-3"
                  :value="item.active"
                  @click="updateActive(item.id)"
              ></v-switch>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" small @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)"> mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  DELETE_TECHNOLOGY,
  GET_DETAIL_TECHNOLOGY,
  GET_LIST_TECHNOLOGY,
  UPDATE_TECHNOLOGY
} from "@/store/modules/technology";


export default {
  name: "technology",
  data(){
    return{
      page: "Danh sách Technology",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách Technology",
          disabled: false,
        },
      ],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
        },
        {text: 'Name', value: 'name'},
        {text: 'Description', value: 'description'},
        {text: 'Photo', value: 'photo_url'},
        {text: 'Hiển thị', value: 'active'},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      url: '',
      selected: -1,

    }
  },
  computed:{
    ...mapGetters({
      technology:"technology",
      technologyDetail:"technologyDetail"
    })
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(GET_LIST_TECHNOLOGY);
  },
  methods:{
    async updateActive(id) {
      await this.$store.dispatch(GET_DETAIL_TECHNOLOGY, id)
      this.technology.forEach(item => {
        if (item.id == id) {
          this.selected = item.active == true ? 1 : 0
        }
      })
      this.technologyDetail.active = this.selected
      await this.$store.dispatch(`${UPDATE_TECHNOLOGY}`, this.technologyDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/technology')
        } else {
          alert(data.data.errors)
        }
      });
    },
    deleteItem(id) {
      confirm('Bạn có chắc chắn muốn xóa không ?') &&
      this.$store.dispatch(`${DELETE_TECHNOLOGY}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_LIST_TECHNOLOGY);
        }
      })
    },
    editItem(id) {
      this.$router.push({
        path: "/technology/edit_technology/" + id,
      });
    },
    add(){
      this.$router.push('/technology/add_technology')
    }
  }
}
</script>

<style scoped>

</style>